import { render, staticRenderFns } from "./Ceremonies.vue?vue&type=template&id=b98d535c"
import script from "./Ceremonies.vue?vue&type=script&lang=js"
export * from "./Ceremonies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports